export default __webpack_public_path__ + "static/retirement-communities_testimonial-0d32b4e3531af5af3fa873d1e5919a9e.jpg";